import { Input, InputAdornment } from '@coolblue-development/freddy';
import focusSearchTrigger from '@coolblue-development/ga4-events/triggers/ProductSpecifications/focusSearchTrigger';
import searchTrigger from '@coolblue-development/ga4-events/triggers/ProductSpecifications/searchTrigger';
import { Magnifier } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import styled from '@emotion/styled';
import { useTranslation } from '@i18n/useTranslation';
import { useId } from 'react';

import { useSpecificationsSearch } from './SearchContext';

export default function SearchField({ productId }: { productId: number }) {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();
  const helperTextId = useId();
  const { queries, setQuery } = useSpecificationsSearch();
  const query = queries.get(productId) ?? '';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setQuery({ id: productId, value: event.target.value });

    trackEvent(
      searchTrigger({
        search_term: event.target.value
      })
    );
  };

  const handleFocus = () => {
    trackEvent(focusSearchTrigger());
  };

  return (
    <>
      <Input
        type='search'
        aria-label={t('productPage.specificationsSearchLabel')}
        aria-describedby={helperTextId}
        placeholder={t('productPage.specificationsSearchLabel')}
        endAdornment={
          <InputAdornment>
            <StyledMagnifier size='large' />
          </InputAdornment>
        }
        value={query}
        onChange={handleChange}
        onFocus={handleFocus}
      />
      <span hidden id={helperTextId}>
        {t('productPage.specificationsSearchHelperText')}
      </span>
    </>
  );
}

const StyledMagnifier = styled(Magnifier)(({ theme }) => ({
  fill: theme.color.icon.base
}));
